document.addEventListener("DOMContentLoaded", () => {
  const firstSlideImage = document.querySelector(
    ".slideshow__slide.is-selected img"
  );

  if (!firstSlideImage) return;

  const triggerInit = () => {
    requestAnimationFrame(() => {
      document.dispatchEvent(new Event("slideshow:ready"));
    });
  };

  if (firstSlideImage.complete) {
    triggerInit();
  } else {
    firstSlideImage.addEventListener("load", triggerInit);
  }
});

document.addEventListener("slideshow:ready", () => {
  const carousels = document.querySelectorAll("slideshow-carousel");
  carousels.forEach((carousel) => {
    if (carousel.initialized) return;
    carousel.initialized = true;
    if (typeof carousel.init === "function") {
      carousel.init();
    }
  });
});
